export const RULES_TYPE=Object.freeze([
    {value:"MOBILE_SMS",name:"手机短信"},
    {value:"WECHAT_PUSH",name:"公众号推送"}
])